import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'
import { enableProdMode, provideZoneChangeDetection } from '@angular/core'
import { environment } from './environments/environment'
import { AppModule } from './app/app.module'
import 'zone.js'

if (environment.production) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
